import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#theme" }),
  /*#__PURE__*/_createTextVNode(" Theme ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Tag provide three different themes: "),
  /*#__PURE__*/_createVNode("code", null, "dark"),
  /*#__PURE__*/_createTextVNode("、"),
  /*#__PURE__*/_createVNode("code", null, "light"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createVNode("code", null, "plain")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "tag-group mb-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  class: "tag-group__title",
  style: {"margin-right":"5px"}
}, "Dark", -1)
const _hoisted_7 = { class: "tag-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", {
  class: "tag-group__title",
  style: {"margin-right":"5px"}
}, "Plain", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createBlock(_component_el_tag, {
            key: item.label,
            type: item.type,
            effect: "dark"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["type"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createBlock(_component_el_tag, {
            key: item.label,
            type: item.type,
            effect: "plain"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["type"]))
        }), 128))
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code5), 1)
        ]),
        _: 1
      })
    ])
  ]))
}